import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../user/authentication.service';
import { OAuthImplicitFlowService } from '../user/oAuthImplicitFlow.service';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService,
    private oAuthImplicitFlowService: OAuthImplicitFlowService,
    private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        this.router.navigate(["error/401"]);
        this.oAuthImplicitFlowService.logOut();
      }
      else if (err.status === 409) {
        this.router.navigate(["error/409"]);
      }
      else if (err.status === 403) {
        this.router.navigate(["forbidden"]);
      }
      else if (err.status === 404) {
        return;
      }
      else {
        console.error(err);
        return throwError(err);
      }
    }))
  }
}
